export default __webpack_public_path__ + "static/media/Hopscotch.e59d19d7.png";